export default {
  templates: [],
  templateInfos: {
    id: null,
    name: null,
    content: null,
    activated: null
  },
  totalPages: 1
}
